import { render, staticRenderFns } from "./WarehousingServices.vue?vue&type=template&id=63f52ff2&scoped=true"
import script from "./WarehousingServices.vue?vue&type=script&lang=js"
export * from "./WarehousingServices.vue?vue&type=script&lang=js"
import style0 from "./WarehousingServices.vue?vue&type=style&index=0&id=63f52ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f52ff2",
  null
  
)

export default component.exports